import type { NodeCustomProps } from '../../../types/craft';
import { FORM_EMAIL_FIELD_NODE_NAME } from '../../../utils/constants';
import { InputBase, defaultProps as defaultInputBaseProps } from './InputBase';
import { FormEmailFieldPropsDto } from '../../../dto/craft/props/FormEmailFieldPropsDto';

export type FormEmailFieldProps = FormEmailFieldPropsDto;

export const defaultProps: FormEmailFieldProps = {
  ...defaultInputBaseProps,
  inputType: 'email',
  label: 'Email',
  placeholder: 'Email',
  primaryEmailField: false,
};

const FormEmailField = (props: Partial<FormEmailFieldProps>) => {
  const mergedProps = { ...defaultProps, ...props };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { primaryEmailField, ...inputBaseProps } = mergedProps;
  return <InputBase {...inputBaseProps} />;
};

FormEmailField.craft = {
  displayName: FORM_EMAIL_FIELD_NODE_NAME,
  props: defaultProps,
  custom: {
    displayName: 'Email',
    isLocked: false,
  } as NodeCustomProps,
};

export default FormEmailField;
